// Simple salt to make encoding less obvious
const SALT = 'roundone';

export const encodeId = (id: string): string => {
  // Combine the ID with salt and encode to base64
  const combined = `${id}:${SALT}`;
  // First encode to base64
  const base64 = btoa(combined);
  // Add some extra transformation to make it less obvious it's base64
  return base64
    .replace(/=/g, '') // Remove base64 padding
    .split('').reverse().join('') // Reverse the string
    .replace(/\+/g, '-') // Replace URL unsafe characters
    .replace(/\//g, '_');
};

export const decodeId = (encoded: string): string | null => {
  try {
    // Reverse the transformations
    const base64 = encoded
      .replace(/-/g, '+')
      .replace(/_/g, '/')
      .split('').reverse().join('');
    
    // Add back base64 padding if needed
    const padding = base64.length % 4;
    const paddedBase64 = padding ? base64 + '='.repeat(4 - padding) : base64;
    
    // Decode base64
    const decoded = atob(paddedBase64);
    
    // Split and verify salt
    const [id, salt] = decoded.split(':');
    if (salt !== SALT) {
      return null;
    }
    
    return id;
  } catch (error) {
    return null;
  }
}; 